<template>
  <div class="view-after-register">
    <p>
      Qual o seu principal interesse na plataforma?
    </p>

    <big-buttons
      v-model="selected"
      login
      :options="[
        {
          id: 'producer',
          name: 'Vender os meus produtos digitais',
          src: require(`@/assets/images/auth-after-register/producer.svg`)
        },
        {
          id: 'affiliate',
          name: 'Vender produtos e ganhar comissões',
          src: require(`@/assets/images/auth-after-register/affiliate.svg`)
        }
      ]"
    />

    <auth-button
      text="Entrar"
      class="mt-2"
      :loading="loading"
      :disabled="!selected || loading"
      @click="submit"
    />
  </div>
</template>

<script>
import AuthButton from "../../components/auth/AuthButton.vue";

export default {
  components: { AuthButton },
  data() {
    return {
      selected: null,
      loading: false
    };
  },
  methods: {
    submit() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-after-register {
  width: 100%;
  p {
    color: var(--std-neut-x-700, #d5d5d5);
  }
}
</style>
